module.exports = __webpack_public_path__ + "img/usecase_enterprise_06.fc95651d.jpg";